import React from 'react';
import PropTypes from 'prop-types';

import * as Styles from './index.styles';

const {
    StyledCard,
    StyledCardColor,
    StyledUpperTagWrapper,
    StyledUpperTag,
    StyledTitleWrapper,
    StyledBottom,
} = Styles;

export const NewCard = ({
    bottom,
    color,
    children,
    dark,
    handleClick,
    title,
    upperTag,
    upperTagWidth,
    upperTagTittle,
    ...otherProps
}) => (
    <StyledCard
        {...otherProps}
        dark={dark}
        onClick={handleClick}
        isClickable={!!handleClick}
        hasColor={!!color}
    >
        {color && <StyledCardColor color={color} />}

        {(title || upperTag) && (
            <StyledTitleWrapper>
                {upperTag && !color && (
                    <StyledUpperTagWrapper title={upperTagTittle}>
                        <StyledUpperTag upperTagWidth={upperTagWidth} dark={dark}>
                            {upperTag}
                        </StyledUpperTag>
                    </StyledUpperTagWrapper>
                )}
                {title && title}
            </StyledTitleWrapper>
        )}

        {children}
        {bottom && <StyledBottom>{bottom}</StyledBottom>}
    </StyledCard>
);

NewCard.propTypes = {
    bottom: PropTypes.node,
    color: PropTypes.string,
    children: PropTypes.node.isRequired,
    dark: PropTypes.bool,
    fullWidth: PropTypes.bool,
    handleClick: PropTypes.func,
    shadow: PropTypes.bool,
    title: PropTypes.node,
    upperTag: PropTypes.node,
    upperTagWidth: PropTypes.string,
    upperTagTittle: PropTypes.string,
    width: PropTypes.string,
};

NewCard.defaultProps = {
    bottom: null,
    color: '',
    dark: false,
    fullWidth: false,
    handleClick: null,
    shadow: false,
    title: '',
    upperTag: null,
    upperTagWidth: '50px',
    upperTagTittle: '',
    width: '330px',
};

NewCard.Styles = Styles;
